import { useState, useEffect } from 'react';

const MAINTENANCE_CONFIG = {
  ENABLED: false,
  BYPASS_PASSWORD: 'mk2025ausbau',
  SESSION_KEY: 'mk_maintenance_bypass',
  MESSAGES: {
    title: 'Website wird überarbeitet',
    subtitle: 'Wir arbeiten an Verbesserungen für Sie',
    description: 'Unsere Website befindet sich derzeit in Überarbeitung. Wir sind bald wieder für Sie da!',
    estimatedTime: 'Voraussichtlich verfügbar ab: 01. September',
    contactNote: 'Für dringende Anfragen kontaktieren Sie uns direkt:'
  }
};

export function useMaintenance() {
  const [isBypassActive, setIsBypassActive] = useState(false);

  useEffect(() => {
    const savedBypass = localStorage.getItem(MAINTENANCE_CONFIG.SESSION_KEY);
    if (savedBypass === 'active') {
      setIsBypassActive(true);
    }
  }, []);

  const attemptBypass = (password) => {
    if (password === MAINTENANCE_CONFIG.BYPASS_PASSWORD) {
      localStorage.setItem(MAINTENANCE_CONFIG.SESSION_KEY, 'active');
      setIsBypassActive(true);
      return true;
    }
    return false;
  };

  const clearBypass = () => {
    localStorage.removeItem(MAINTENANCE_CONFIG.SESSION_KEY);
    setIsBypassActive(false);
  };

  const isMaintenanceActive = MAINTENANCE_CONFIG.ENABLED && !isBypassActive;

  return { 
    isMaintenanceActive, 
    attemptBypass, 
    clearBypass, 
    isBypassActive,
    config: MAINTENANCE_CONFIG 
  };
}